<div class="container-fluid zsd_global_search_page">
    <div class="row zsd_global_search_store" #zsdGlobalSearchStore>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pb-2" id="sd_global_search_heading_store">
            {{ 'StoreItems.storeitemsHeader' | translate }} 
            <span [ngClass]="(toggleIconFlag == true)? 'icon-circle-up' : 'icon-circle-down'"  (click)="toggleStore()" style="cursor:pointer;"></span>
        </div>
        <div (window:resize)="onResizeCalculateItemsPerRow()" id="storeCarouselControls" class="carousel slide w-100 px-lg-5 px-sm-4" data-ride="carousel"
             data-interval="false">
            <div class="carousel-inner">
                <!-- Spinner -->
                <div class="text-center col-12" id="sd_store_item_loading ">
                    <div *ngIf="isLoading || spinnerStart" id="spinner" role="progressbar">
                        <zsd-spinner></zsd-spinner>
                    </div>
                </div>
                <div *ngIf="!isStoreItems && !isLoading && !spinnerStart" class="text-center" id="store_items_message">
                    {{ 'StoreItems.noStoreItemsMessage' | translate }}
                </div>
                <div class="carousel-item " *ngFor="let row of rowList;let i=index;" [ngClass]="{'active':i === carouselPage}" [attr.data-slide-to]="i">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-6 col-sm-4 col-md-4 col-lg-3 col-xl-2" *ngFor="let storeItem of row;" style="display:inline-block;">
                                <a routerLink='/store/{{ storeItem.storeItemId }}' id="store_item_detail_link">
                                    <div class="card" id="sd_store_card">
                                        <div class="card-body" id="override_card_body">
                                            <!--<span *ngIf="storeItem.myRequested">
                                                <img src="img/icon-requested.png" style="float: right;" />
                                            </span>-->
                                            <img id="card_image" class="card-top-img mt-4" [src]="_DomSanitizer.bypassSecurityTrustUrl('data:' + storeItem.iconMime + ';base64, ' + storeItem.iconData)">
                                        </div>
                                        <div class="card-footer text-center pb-3" id="store_item_name" *ngIf="storeItem.storeItemName.length<23; else elseBlock"
                                            [innerHTML]="storeItem.storeItemName"></div>
                                        <ng-template #elseBlock>
                                            <div class="card-footer text-center pb-3" id="store_item_name_lg" data-animation="true" data-toggle="tooltip" data-placement="left"
                                                title="{{storeItem.storeItemName}}" [innerHTML]="storeItem.storeItemName.slice(0,20)+'...'">
                                            </div>
                                        </ng-template>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <a class="carousel-control-prev zsd_carousel_control_prev" href="#storeCarouselControls" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next zsd_carousel_control_next" href="#storeCarouselControls" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>

        </div>


    </div>


    <!-- Requests -->
    <div class="row zsd_global_search_requests_heading" [style.paddingTop]=storeHeight>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pb-2" id="sd_global_search_heading_request">
            {{ 'Requests.requestHeader' | translate }}
        </div>
    </div>
    <div class="row" [style.paddingTop]=requestsHeight>
        <div id="requestlist_container" class="col-12 col-md-12 col-xl-12 col-lg-12 col-sm-12">
            <zsd-requestslist></zsd-requestslist>
        </div>
    </div>
</div>